import { render } from "./QuestionnaireAuth.vue?vue&type=template&id=615912f5&scoped=true"
import script from "./QuestionnaireAuth.vue?vue&type=script&lang=js"
export * from "./QuestionnaireAuth.vue?vue&type=script&lang=js"

import "./QuestionnaireAuth.vue?vue&type=style&index=0&id=615912f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615912f5"]])

export default __exports__